import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal, grey } from '@material-ui/core/colors';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CustomButtonOLLight from './CustomButtonOLLight';
import CustomButtonOLDailyBlue from './CustomButtonOLDailyBlue';
import CustomButtonOLDailyDigital from './CustomButtonOLDailyDigital';
import NewsList from './NewsList';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

/**
* 折り畳み表示
* 'openHere'というクラスに属するオブジェクトをインライン要素or非表示に変更する。
*/
const openClose = (id) => {
  console.log(id);
  var obj = document.getElementsByClassName(`openHere ${id}`);
  for(var i=0;i<obj.length;i++){
      //非表示ならインライン要素に変更。表示状態なら非表示に変更。
      if(obj[i].style.display == "inline-block"){
          obj[i].style.display = "none";
      }
      else{
          obj[i].style.display = "inline-block";
      }
  }
}

const testClick = () => {
  alert(`ボタンがクリックされました`);
}

function Home() {
  const classes = useStyles();
  {/*
  // お知らせテスト
  window.onload = function () {
  // ロード時にAPIを呼び出す
    const API_URL = "https://api.sssapi.app/vPxrQ3DPI0c3Dg9o4AOrC";
    fetch(API_URL).then((response) => {
      if (response.status != 200) {
        // APIの呼び出しが失敗した場合
        console.log(response.status);
        return response
          .json()
          .then((error) => alert(JSON.stringify(error, null, 2)));
      }

      // APIの呼び出しが成功した場合
      return response
        .json() // JSONデータを取得
        .then((data) => {
          // 取得したデータを挿入
          document.getElementById("infomation").innerHTML += `<span onclick={testClick}>ここをクリック</span>`;
        });
    });
  };
  */}

  return (
    <div className={classes.root}>
      <div className="wrap">
        {/* <video autoPlay muted playsInline loop id="bg-video">
          <source src="/movie/movie-bg.webm" type="video/webm"></source>
          <source src="/movie/movie-bg.mp4" type="video/mp4"></source>
          <source src="/movie/movie-bg.ogg" type="video/ogg"></source>
        </video> */}

        <Box className="content-wrap">
          <div className="header-title">
            {/*
              <Grid className="p-3 my-4" spacing={0} container direction="row" justify="center">
                <Grid item xs={10} sm={8} md={6}>
                  <img src="/images/logo-top.png" className="img-fluid" />
                </Grid>
              </Grid>
            */}

            <div className="top-menu-wrap">

              <div className="top-menu-content text-left">

                {/*
                <Grid spacing={1} container direction="row" justifyContent="center" alignItems="center">
                  <Grid item xs={12} sm={9} md={9}>
                    <Grid spacing={1} container direction="row" justifyContent="center" alignItems="center" style={{ margin: "3.0rem 0", border: "2px solid red", padding: "0.5rem 1.5rem" }}>
                      <Grid item xs={12} sm={8} md={8}>
                        【復旧のお知らせ】<br />
                        ニュースサイト「デーリー東北デジタル」は19日午後４時ごろからシステム障害のため閲覧できない状態になっておりましたが、同日午後９時ごろ復旧いたしました。ユーザーの皆様にはご不便とご迷惑をおかけしましたことをあらためてお詫び申し上げます。<br />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <div class="text-center mx-auto my-3">
                          <a href="https://static.daily-tohoku.news/nepcell/viewer/viewer.html">
                            <img src="https://static.daily-tohoku.news/nepcell/viewer/images/sougou1men.png" class="img-fluid" /><br />
                            <small class="my-2 text-danger">画像をクリックすると電子紙面が閲覧できます。</small>
                          </a>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                */}

                
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={12} sm={12} lg={6}>
                    <div class="p-2">
                      <img src="/images/20260519_luncheonmat.jpg" className="img-fluid" />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} lg={6}>
                    <Typography className="text-left my-3" variant="h6" component="h2">デーリー東北のランチョンマット企画広告に金賞／オーストラリアの広告業界紙主催「ケアンズ・クロコダイルズ・アワード」</Typography>
                    　デーリー東北新聞社が電通（東京）と共同で手がけた創刊80周年特集号「北奥羽の食」で展開したランチョンマット企画広告が、オーストラリアの広告業界紙「Ｂ＆Ｔ」など主催の「ケアンズ・クロコダイルズ・アワード2026」で、プリント＆パブリッシング・キャンペーン部門の1位に当たる金賞を受賞しました。<br /><br />
                    　アワードはアジア太平洋地域の広告やクリエーティブ作品を対象に行われ、電通が今回の企画広告を「Ｏｕｒ　Ｐｒｅｓｓ　Ｍａｔ」とのタイトルを冠して応募。5月14日夜、現地で開かれた授賞式で受賞が発表されました。<br /><br />
                    　「北奥羽の食」は2025年12月2日付で発行した、北奥羽地方の食にまつわる話題や読者参加型企画「復―１グランプリ」などを盛り込んだ特集紙面です。「読む」だけにとどまらず、表紙と裏表紙を広げ、食卓で「使う」ランチョンマットとして設計しました。食をテーマに家族や友人との会話を生む紙面を目指し、デザインや構成も食事の場で使うことを意識した工夫を取り入れました。<br /><br />
                    　アワードの審査員からは「これはまさに印刷媒体ならではの発想。新聞の物理的なサイズや特性をデジタルでは再現できない形で活用している。開いた新聞を、人々の間に置かれ会話のきっかけとなるランチョンマットに変えるというアイデアは、シンプルで魅力的であり、まさにこのカテゴリーにふさわしい」「紙のサイズと食卓のサイズという、シンプルで身近な視点を取り上げ、それを使って印刷媒体の意義を再定義することは、コミュニティーとのつながりを再構築する強力な方法だ」「本当に素晴らしいアイデア。強力なメディア露出を生み出した」などのコメントが寄せられました。<br />
                  </Grid>
                </Grid>

{/*
                <Box mt={10}>
                  <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                    <Grid item xs={12} sm={12} lg={6}>
                      <div class="p-2">
                        <img src="/images/20260424_michill_main.jpg" className="img-fluid" />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <Typography className="text-left my-3" variant="h6" component="h2">ミチル種差「ふるさとあおもり景観賞」最優秀賞　民間建築物部門</Typography>
                      　青森県が主催する第18回「ふるさとあおもり景観賞」民間建築物部門の最優秀賞に、デーリー東北新聞社の子会社・DTプロジェクトが運営する「michill TANESASHI（ミチル種差）」が選ばれました。「道」をテーマとしたコンセプトが明確で、低層建物の屋根勾配や色彩が周囲の景観と調和するよう丁寧に造られている点が高く評価されました。<br />
                      　「ふるさとあおもり景観賞」は、青森県内の良好な景観づくりに貢献している街並みやまちづくり活動を表彰することで、魅力ある景観形成への県民意識を高め、美しい景観づくりに寄与することを目的にしています。今回は土木施設、公共建築物、民間建築物、地域づくり活動の計４部門に14件の応募がありました。<br />
                      　表彰式は６月２日（火）、青森市新町１丁目のアウガ５階男女共同参画プラザ・カダールAV多機能ホールで開催されます。受賞者のDTプロジェクトと、レストラン棟・外構設計者の大成建設東北支店一級建築士事務所（仙台市）、宿泊棟設計者の玉川設計（南部町）に表彰状が贈られます。<br />
                      　ミチル種差は八戸市鮫町の種差海岸芝生地エリアにある、飲食と宿泊を核とした複合施設です。物販とテイクアウト部門を備えたレストラン棟、宿泊棟３棟で構成し、2025年５月にオープンしました。<br />
                    </Grid>
                  </Grid>
                  <Grid spacing={2} container direction="row" justify="left" alignItems="center"  className="my-3">
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <Box sx={{width: '100%', height: {xs: 200, sm: 200, md: 250, lg: 250,}, overflow: 'hidden',}}>
                        <img src="/images/20260424_michill_sub01.jpg" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <Box sx={{width: '100%', height: {xs: 200, sm: 200, md: 250, lg: 250,}, overflow: 'hidden',}}>
                        <img src="/images/20260424_michill_sub02.jpg" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <Box sx={{width: '100%', height: {xs: 200, sm: 200, md: 250, lg: 250,}, overflow: 'hidden',}}>
                        <img src="/images/20260424_michill_sub03.jpg" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <Box sx={{width: '100%', height: {xs: 200, sm: 200, md: 250, lg: 250,}, overflow: 'hidden',}}>
                        <img src="/images/20260424_michill_sub04.jpg" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <Box sx={{width: '100%', height: {xs: 200, sm: 200, md: 250, lg: 250,}, overflow: 'hidden',}}>
                        <img src="/images/20260424_michill_sub05.jpg" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
*/}

              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">デーリー東北からのお知らせ</Typography>
                <NewsList/>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">会社案内</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-overview" className="aaa px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">会社概要</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://recruit.daily-tohoku.company/" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">採用情報</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-shop" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">購読のご案内</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-advertisement" className="aaa px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">広告・折込のご案内</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                </Grid>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">事業・チケット案内</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://event-guide.daily-tohoku.news/#sec-event" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">主催事業</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://event-guide.daily-tohoku.news/#sec-ticket" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">チケット情報</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/forum" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">政経懇話会</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                </Grid>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">各種サービス</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://tomonokai.daily-tohoku.news/" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">デーリー友の会</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://event-guide.daily-tohoku.news/about-delion" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">デリオンとは</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-facility" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">ホール貸出</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://form.daily-tohoku.org/shoseki-top" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">書　籍</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/support" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">後援願い</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://form.daily-tohoku.org/" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">バックナンバー販売</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/printservice" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">掲載写真販売</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/tour" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">会社見学</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-service" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">NIE</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={8} md={6}>
                    <CustomButtonOLDailyDigital href="https://www.daily-tohoku.news" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">デーリー東北・デジタル版へ<i class="fas fa-arrow-circle-right"></i></div>
                    </CustomButtonOLDailyDigital>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyDigital href="https://dtmagocoro.com/" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">デーリー東北まごころサポート<i class="fas fa-arrow-circle-right"></i></div>
                    </CustomButtonOLDailyDigital>
                  </Grid>
                </Grid>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">投稿・各種お問い合わせ</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-wanted" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">投稿・応募</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/contactus" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">お問い合わせ</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  {/*
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue id="open" href="/info" className="px-1 py-2 d-block" size="small" themeColor={grey}>
                      <div className="absolute-transform line160">関連会社役員の新型コロナ<br />ウイルス感染について</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <CustomButtonOLDailyBlue id="open" href="javascript:void(0);" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">もっと「つかって」デーリー東北</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  */}
                </Grid>
              </div>
            </div>
          </div>
          {/*
          <div className="d-none d-md-block">
            <img src="/images/da002.png" className="img-fluid" />
          </div>
          */}
        </Box>
      </div>
    </div>
  );
}

export default Home;
